import request from '@/utils/request'
import { BaseDataUpdateModule } from '@/utils/baseDataUpdateModule'

export function page(params) {
  return request({
    url: '/api/bdPort/page',
    method: 'get',
    params
  })
}

export function add(data, lastUpdateModule = BaseDataUpdateModule.BASE_DATA) {
  return request({
    url: '/api/bdPort',
    method: 'post',
    data: { ...data, lastUpdateModule }
  })
}

export function update(data, lastUpdateModule = BaseDataUpdateModule.BASE_DATA) {
  return request({
    url: '/api/bdPort',
    method: 'put',
    data: { ...data, lastUpdateModule }
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/bdPort/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/bdPort',
    method: 'get',
    params: {
      id
    }
  })
}

export function generateAreas() {
  return request({
    url: '/api/bdPort/generateAreas',
    method: 'post'
  })
}

export function options(mainPortId=null) {
  return request({
    url: '/api/bdPort/options',
    method: 'get',
    params:{mainPortId}
  })
}

export function findNearPorts(lng, lat) {
  return request({
    url: '/api/bdPort/findNearPorts',
    method: 'get',
    params:{lng, lat}
  })
}

export function nearbyPortBerths(lng, lat) {
  return request({
    url: '/api/bdPort/nearbyPortBerths',
    method: 'get',
    params: { lng, lat }
  })
}

export function identifyPortBerth(lng, lat) {
  return request({
    url: '/api/bdPort/identifyPortBerth',
    method: 'get',
    params: { lng, lat }
  })
}
